// AUTO-GENERATED FILE — DO NOT EDIT
// Generated by scripts/generate-routes.ts
// Run `pnpm run build:routes` to regenerate.

export const ROUTE_TREE = {
  "home": "/",
  "pricing": "/pricing",
  "checkout": "/checkout",
  "legal": "/legal",
  "blog": "/blog",
  "about": "/about",
  "contact": "/contact",
  "dashboard": "/learn",
  "studyPanel": {
    "base": "/learn/dashboard"
  },
  "docs": {
    "base": "/docs"
  },
  "internalDocs": {
    "base": "/internal-docs"
  },
  "auth": {
    "login": "/login",
    "signup": "/signup",
    "forgotPassword": "/forgot-password",
    "verify": "/verify",
    "onboarding": "/onboarding",
    "resetPassword": "/reset-password",
    "logout": "/logout"
  },
  "collections": {
    "base": "/learn/programs",
    "detail": "/learn/programs/:collectionSlug"
  },
  "courses": {
    "base": "/learn/tracks",
    "detail": "/learn/tracks/:courseId"
  },
  "marketing": {
    "collectionDetail": "/programs/:collectionSlug",
    "courses": "/tracks",
    "courseDetail": "/tracks/:courseSlug",
    "coursePreview": "/tracks/:courseSlug/preview"
  },
  "publicCourses": {
    "base": "/tracks",
    "detail": "/tracks/:courseSlug",
    "preview": "/tracks/:courseSlug/preview",
    "info": "/tracks/:courseSlug/info"
  },
  "resources": {
    "themeSwitch": "/resources/theme-switch",
    "downloadUserData": "/resources/download-user-data"
  },
  "topics": {
    "base": "/learn/topics",
    "detail": "/learn/tracks/:courseId/topics/:topicId",
    "resources": {
      "base": "/learn/tracks/:courseId/resources",
      "detail": "/learn/tracks/:courseId/resources/:resourceId"
    }
  },
  "settings": {
    "base": "/settings",
    "account": "/settings/account",
    "appearance": "/settings/appearance",
    "billing": "/settings/billing",
    "profile": "/settings/profile-basic",
    "notifications": "/settings/notifications",
    "display": "/settings/display"
  },
  "admin": {
    "users": {
      "base": "/admin/users",
      "view": "/admin/users/:userId",
      "edit": "/admin/users/:userId/edit",
      "delete": "/admin/users/:userId/delete",
      "impersonate": "/admin/users/:userId/impersonate"
    },
    "roles": {
      "base": "/admin/roles",
      "view": "/admin/roles/:roleId",
      "edit": "/admin/roles/:roleId/edit",
      "delete": "/admin/roles/:roleId/delete"
    },
    "courses": {
      "base": "/admin/tracks",
      "view": "/admin/tracks/:courseId",
      "edit": "/admin/tracks/:courseId/edit",
      "delete": "/admin/tracks/:courseId/delete",
      "creation": {
        "base": "/admin/tracks/creation",
        "list": "/admin/recent-creations"
      }
    },
    "categories": {
      "base": "/admin/categories"
    },
    "configStudio": {
      "base": "/admin/configStudio"
    },
    "emailStudio": {
      "base": "/admin/emailStudio"
    }
  }
} as const

export type RouteKey = 'home' | 'pricing' | 'checkout' | 'legal' | 'blog' | 'about' | 'contact' | 'dashboard' | 'studyPanel.base' | 'docs.base' | 'internalDocs.base' | 'auth.login' | 'auth.signup' | 'auth.forgotPassword' | 'auth.verify' | 'auth.onboarding' | 'auth.resetPassword' | 'auth.logout' | 'collections.base' | 'collections.detail' | 'courses.base' | 'courses.detail' | 'marketing.collectionDetail' | 'marketing.courses' | 'marketing.courseDetail' | 'marketing.coursePreview' | 'publicCourses.base' | 'publicCourses.detail' | 'publicCourses.preview' | 'publicCourses.info' | 'resources.themeSwitch' | 'resources.downloadUserData' | 'topics.base' | 'topics.detail' | 'topics.resources.base' | 'topics.resources.detail' | 'settings.base' | 'settings.account' | 'settings.appearance' | 'settings.billing' | 'settings.profile' | 'settings.notifications' | 'settings.display' | 'admin.users.base' | 'admin.users.view' | 'admin.users.edit' | 'admin.users.delete' | 'admin.users.impersonate' | 'admin.roles.base' | 'admin.roles.view' | 'admin.roles.edit' | 'admin.roles.delete' | 'admin.courses.base' | 'admin.courses.view' | 'admin.courses.edit' | 'admin.courses.delete' | 'admin.courses.creation.base' | 'admin.courses.creation.list' | 'admin.categories.base' | 'admin.configStudio.base' | 'admin.emailStudio.base'

export const routeMap = {
  'home': '/' as const,
  'pricing': '/pricing' as const,
  'checkout': '/checkout' as const,
  'legal': '/legal' as const,
  'blog': '/blog' as const,
  'about': '/about' as const,
  'contact': '/contact' as const,
  'dashboard': '/learn' as const,
  'studyPanel.base': '/learn/dashboard' as const,
  'docs.base': '/docs' as const,
  'internalDocs.base': '/internal-docs' as const,
  'auth.login': '/login' as const,
  'auth.signup': '/signup' as const,
  'auth.forgotPassword': '/forgot-password' as const,
  'auth.verify': '/verify' as const,
  'auth.onboarding': '/onboarding' as const,
  'auth.resetPassword': '/reset-password' as const,
  'auth.logout': '/logout' as const,
  'collections.base': '/learn/programs' as const,
  'collections.detail': '/learn/programs/:collectionSlug' as const,
  'courses.base': '/learn/tracks' as const,
  'courses.detail': '/learn/tracks/:courseId' as const,
  'marketing.collectionDetail': '/programs/:collectionSlug' as const,
  'marketing.courses': '/tracks' as const,
  'marketing.courseDetail': '/tracks/:courseSlug' as const,
  'marketing.coursePreview': '/tracks/:courseSlug/preview' as const,
  'publicCourses.base': '/tracks' as const,
  'publicCourses.detail': '/tracks/:courseSlug' as const,
  'publicCourses.preview': '/tracks/:courseSlug/preview' as const,
  'publicCourses.info': '/tracks/:courseSlug/info' as const,
  'resources.themeSwitch': '/resources/theme-switch' as const,
  'resources.downloadUserData': '/resources/download-user-data' as const,
  'topics.base': '/learn/topics' as const,
  'topics.detail': '/learn/tracks/:courseId/topics/:topicId' as const,
  'topics.resources.base': '/learn/tracks/:courseId/resources' as const,
  'topics.resources.detail': '/learn/tracks/:courseId/resources/:resourceId' as const,
  'settings.base': '/settings' as const,
  'settings.account': '/settings/account' as const,
  'settings.appearance': '/settings/appearance' as const,
  'settings.billing': '/settings/billing' as const,
  'settings.profile': '/settings/profile-basic' as const,
  'settings.notifications': '/settings/notifications' as const,
  'settings.display': '/settings/display' as const,
  'admin.users.base': '/admin/users' as const,
  'admin.users.view': '/admin/users/:userId' as const,
  'admin.users.edit': '/admin/users/:userId/edit' as const,
  'admin.users.delete': '/admin/users/:userId/delete' as const,
  'admin.users.impersonate': '/admin/users/:userId/impersonate' as const,
  'admin.roles.base': '/admin/roles' as const,
  'admin.roles.view': '/admin/roles/:roleId' as const,
  'admin.roles.edit': '/admin/roles/:roleId/edit' as const,
  'admin.roles.delete': '/admin/roles/:roleId/delete' as const,
  'admin.courses.base': '/admin/tracks' as const,
  'admin.courses.view': '/admin/tracks/:courseId' as const,
  'admin.courses.edit': '/admin/tracks/:courseId/edit' as const,
  'admin.courses.delete': '/admin/tracks/:courseId/delete' as const,
  'admin.courses.creation.base': '/admin/tracks/creation' as const,
  'admin.courses.creation.list': '/admin/recent-creations' as const,
  'admin.categories.base': '/admin/categories' as const,
  'admin.configStudio.base': '/admin/configStudio' as const,
  'admin.emailStudio.base': '/admin/emailStudio' as const
} as const

export function path<K extends RouteKey>(key: K): (typeof routeMap)[K] {
  return routeMap[key]
}

export function build<K extends RouteKey>(key: K, params: Record<string, string | number>): string {
  return replaceParams(routeMap[key], params)
}

// Internal helper (not exported)
function replaceParams(template: string, params: Record<string, string | number>): string {
  return template.replace(/:([A-Za-z0-9_]+)/g, (_, p: string) => {
    if (!(p in params)) {
      throw new Error('Missing route param: ' + p)
    }
    return String(params[p])
  })
}
